<template>
    <div class="overall-situation">
    <div class="situation">
      <back-box style="width: 100%" />
      <div class="Group">
        <span>版权存证</span>
      </div>
      
      <div class="formBoxx">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px">
          <el-form-item label="作品名称" prop="worksName">
            <el-input :disabled="acceptStr.isType" placeholder="请输入作品名称" v-model="ruleForm.worksName" clearable></el-input>
          </el-form-item>
          <el-form-item label="作品所有者" prop="ownerUsn">
            <el-select v-model="ruleForm.ownerUsn" filterable remote reserve-keyword placeholder="请输入作品所有者" :disabled="acceptStr.isType" :remote-method="remoteMethod" :loading="loadings">
              <el-option v-for="item,index in ownerData" :key="index" :label="item.truename||item.nickname||item.username" :value="item.usn">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="作品类型" prop="worksType">
            <el-select v-model="ruleForm.worksType" placeholder="请选择作品类型" clearable :disabled="acceptStr.isType">
              <el-option v-for="item,index in worksTypeData" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="作品类型"  style="width: 70%" prop="worksType">
            <el-radio  :disabled="acceptStr.isType"  text-color="#1C77FF" fill="#1C77FF" v-model="ruleForm.worksType" v-for="item,index in worksTypeData" :key="index" :value="item.value" :label="item.value">{{item.label}}</el-radio>
           
          </el-form-item>
          <el-form-item label="作品文件" prop="fileList">
          <div v-if="!acceptStr.isType">
            <el-upload
            style="width: 25%"
              class="upload-demo"
              :disabled="acceptStr.isType"
              :http-request="handleRequest" 
              :on-remove="handleRemove" 
              :file-list="ruleForm.fileList"
              drag
              action="https://jsonplaceholder.typicode.com/posts/"
              multiple>
              <i><img src="../../../../assets/image/1254.png" style="width: 26px;
              height: 26px;
              margin-top: 60px;
              " alt=""> </i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div style=" margin-top: -15px;" class="el-upload__text">支持扩展名：.rar .zip .doc .docx .pdf .jpg...</div>
            </el-upload>
          </div>
          <div v-else v-for="item in ruleForm.fileList" class="imgname">
            <img class="teat"  :src="imgUrl + item.name" alt="" @click="view(item)">
          </div>
          <!-- <img class="teat" v-else :src="ruleForm.fileList" alt="" @click="view(ruleForm.fileList)"> -->
          </el-form-item>
        </el-form>
        <div class="but-el">
            <el-button v-if="!acceptStr.isType" @click="handleCancel()">取消</el-button>
            <el-button type="primary" v-if="!acceptStr.isType" @click="handleSubmit('ruleForm')">提交</el-button>
        </div>
      </div>
      
    </div>
</div>
  </template>
  
  <script>
  // import { evidenceList, examineDetail } from "@/api/interface";
  import { searchUserByKeyword, postUpdate, postCollect } from "@/api/interface";
  export default {
    data() {
      var checkFileList = (rule, value, callback) => {
        if (value.length>0) {
          callback();
        } else {
          callback(new Error('请选择作品文件'));
        }
  
      };
      return {
        imgUrl:'https://files.wespace.cn/',
        ruleForm: {
          id: '',
          applicantUsn: '',//申请人usn
          orgUsn: 'bb856cc72818c5226d4226728a16fcd19911de041446e4759c58017cb146ddcc',//机构usn
          worksName: '',//作品名称
          ownerUsn: '',//作品所有者
          worksType: '',//作品类型
          worksFile: null,//作品文件
          fileList: [],//文件列表-不提交
        },
        rules: {
          worksName: [
            { required: true, message: '请输入作品名称', trigger: 'blur' },
          ],
          ownerUsn: [
            { required: true, message: '请选择作品所有者', trigger: 'change' },
          ],
          worksType: [
            { required: true, message: '请选择作品类型', trigger: 'change' },
          ],
          fileList: [
            { required: true, validator: checkFileList, message: '请选择作品文件', trigger: 'change' },
          ],
        },
        acceptStr: {  
          isType: false
        },
        loadings: false,
        ownerData: [],
        worksTypeData: [
          {
            label: '文字',
            value: '1'
          },
          {
            label: '口述',
            value: '2'
          },
          {
            label: '音乐',
            value: '3'
          },
          {
            label: '戏剧',
            value: '4'
          },
          {
            label: '曲艺',
            value: '5'
          },
          {
            label: '舞蹈',
            value: '6'
          },
          {
            label: '杂技',
            value: '7'
          },
          {
            label: '美术',
            value: '8'
          },
          {
            label: '建筑',
            value: '9'
          },
          {
            label: '摄影',
            value: '10'
          },
          {
            label: '电影',
            value: '11'
          },
          {
            label: '类似摄制电影方法创作',
            value: '12'
          },
          {
            label: '工程设计图、产品设计图',
            value: '13'
          },
          {
            label: '地图、示意图',
            value: '15'
          },
          {
            label: '模型',
            value: '17'
          },
          {
            label: '录音制品',
            value: '19'
          },
          {
            label: '录像制品',
            value: '20'
          },
          {
            label: '其他作品',
            value: '181'
          },
  
        ],
        isClear: false,
        worksPathType: '',
        worksPath: '',
  
      }
    },
    created() {
      this.ruleForm.applicantUsn = this.$store.state.userData.usn;
  
      if (this.$route.query.id) {
        this.ruleForm.id = this.$route.query.id;
        this.ruleForm.worksName = this.$route.query.worksName;
        this.ruleForm.worksType = this.$route.query.worksType;
        this.ruleForm.fileList.push({ name: this.$route.query.worksFile });
        this.ruleForm.ownerUsn = this.$route.query.ownerUsn;
        this.remoteMethod(this.$route.query.ownerName);
        this.$route.query.type==2?this.acceptStr.isType = true:this.acceptStr.isType =false
      } else {
        if (this.$store.state.userData && this.$store.state.userData.truename) {
          this.ruleForm.ownerUsn = this.$store.state.userData.usn;
          this.remoteMethod(this.$store.state.userData.truename, 1)
  
        }
      }
    },
    methods: {
      view(type) {
        // console.log("type",type)
        window.open( this.imgUrl + type.name, "_blank");
      },
      handleSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const loading = this.loading();
            let fd = new FormData();
            fd.append("applicantUsn", this.ruleForm.applicantUsn);
            fd.append("orgUsn", this.ruleForm.orgUsn);
            fd.append("worksName", this.ruleForm.worksName);
            fd.append("ownerUsn", this.ruleForm.ownerUsn);
            fd.append("worksType", this.ruleForm.worksType);
            let ip
            if (this.ruleForm.worksFile) {
              fd.append("worksFile", this.ruleForm.worksFile);
            }
  
            if (this.ruleForm.id) {
              fd.append("id", this.ruleForm.id);
              // ip = '/storage/evidence/update';
              postUpdate(fd).then(res =>{
                console.log(res);
                loading.close();
                if (res.code == 200) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$router.push({ path: "/preservaTion"});
                } else {
                  this.$message.error(res.data.message);
                }
              })
            } else {
              postCollect(fd).then(res =>{
                console.log(res);
                loading.close();
                if (res.code == 200) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$router.push({path: "/preservaTion"});
                } else {
                  this.$message.error(res.message);
                }
              })
              // ip = '/storage/evidence/info/collect';
            }
  
          //   this.$axios.post(this.$store.state.copyrightApi_url + ip,
          //     fd,
          // {headers :{ 'authorization':'Basic' + sessionStorage.getItem('usn-token')}}
          //   ).then(res => {
          //     console.log(res);
          //     loading.close();
          //     if (res.data.code == 200) {
          //       this.$message({
          //         message: '提交成功',
          //         type: 'success'
          //       });
          //       this.$router.push({path: "/preservaTion"});
          //     } else {
          //       this.$message.error(res.data.message);
          //     }
          //   })
            // 
          }
        })
      },
      handleCancel(){
        this.$router.push({path: "/preservaTion"});
      },
      handleRemove() {
        this.ruleForm.worksFile = null;
        this.ruleForm.fileList = [];
      },
      handleRequest(val) {
        this.ruleForm.fileList = [];
        this.ruleForm.worksFile = val.file;
        this.ruleForm.fileList = [{name:val.file.name}];
        this.$refs['ruleForm'].clearValidate('fileList');
      },
      remoteMethod(query) {
        if (query !== '') {
          this.loadings = true;
          // this.$axiosPost(this.$store.state.login_url + "/userInfo/searchUserByKeyword", {
          // this.$axiosPost(this.$store.state.node_url + "userApi/userInfo/searchUserByKeyword", {
          //   keyword: query
          // },
          // {headers :{ 'authorization':'Basic' + sessionStorage.getItem('usn-token')}})
          searchUserByKeyword({ keyword: query}).then(res => {
            this.loadings = false;
            if (res.code == 200) {
              this.ownerData = res.data.filter(item => {
                return item.truename.toLowerCase().indexOf(query.toLowerCase()) > -1;
              })
            }
          })
  
        } else {
          this.ownerData = [];
        }
      },
  
    }
  }
  </script>
  <style  lang="scss">
  .imgname{
    width: 300px;
    height: 300px;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #333 !important;
  }
  /* 选中后小圆点的颜色 */
  .el-radio__input.is-checked .el-radio__inner {
    background: #1C77FF !important;
    border-color: #1C77FF !important;
  }
  .el-icon-document:before {
      content: "\E77D";
  }
  .top {
    height: 22px;
    padding: 38px 33px;
    h1 {
      float: left;
      color: #333;
      line-height: 22px;
      // font-size: 24px;
      margin: 0;
    }
  }
  .elWorksFile {
    width: 50%;
  }
 .but-el{
    text-align: center;
    margin: 0 auto;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    
   
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #1C77FF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  ::v-deep.el-upload--picture-card:hover,
  .el-upload:focus {
    border-color: #1C77FF;
    color: #1C77FF;
  }
  ::v-deep.avatar-uploader-icon {
    border: 1px dashed #c0ccda;
  }
  .el-input {
    width: 218px;
  }
  .overall-situation{
  padding-bottom: 50px;
  padding-top: 20px;
  .situation{
    margin: 0 auto;
    min-width: 1200px;
    max-width: 1200px;
    padding: 20px 20px 20px 20px;
    background: #FFFFFF;
    opacity: 1;
    .Group{
      display: flex;
      margin: 30px;
      span{
        margin-left: 10px;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
    }
    .topTitle{
      // font-size: 24px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
  }
  .statesBox {
        display: flex;
        justify-content: center;

    div {
        width: 60px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .states {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 8px;
        float: left;
    }

    .statesAdopt {
        //状态-通过
        background: #2DA55D;
    }

    .statesFail {
        //状态-不通过
        background: #E05F42;
    }

    .statesSubmit {
        //状态-待提交
        background: #954EFF;
    }

    .statesReviewed {
        //状态-待审核
        background: #4E77FF;
    }
    .statesConduct{
        //状态-待审核
        background: #FFC300;
    }
}
    
}
  </style>
  